import React, { createContext, useContext } from 'react';
import { langBase, pathIn } from '../lib/basePath';
import { blogArticles } from '../data/blogData';

const LanguageContext = createContext(undefined);

// The language comes from the address: /en/… is English, everything else is
// French, so that each language has its own pages for search engines. The
// choice made with the FR/EN button is remembered: the homepage sends a
// visitor who chose English to /en (see index.js).
export const LANG_KEY = 'jarvis-lang';

// The same page in the other language; articles have their own slug.
export function counterpartPath(pathname, next) {
  let path = pathname.replace(/^\/en(?=\/|$)/, '') || '/';
  const blog = path.match(/^\/100xWorks\/blog\/([^/]+)$/);
  if (blog) {
    const article = ['fr', 'en']
      .flatMap((l) => blogArticles[l].articles)
      .find((a) => a.slug === blog[1]);
    if (article?.translationSlug) path = `/100xWorks/blog/${article.translationSlug}`;
  }
  return pathIn(next, path);
}

export const LanguageProvider = ({ children }) => {
  const lang = langBase() ? 'en' : 'fr';

  const toggleLang = () => {
    const next = lang === 'fr' ? 'en' : 'fr';
    try { localStorage.setItem(LANG_KEY, next); } catch { /* private mode */ }
    window.location.assign(counterpartPath(window.location.pathname, next) + window.location.hash);
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};
